import { Point } from '@kaiizen/kai-floor-plan';
import { screenToModel, Viewport } from '@kaiizen/kai-floor-plan-editor-core';

/** Pointer event → model-space point, relative to the given SVG element. */
export function screenToModelPoint(vp: Viewport, svgEl: SVGSVGElement, e: PointerEvent): Point {
  const r = svgEl.getBoundingClientRect();
  const screen = { x: e.clientX - r.left, y: e.clientY - r.top };
  return screenToModel(vp, screen);
}

/** Pointer event → screen-space point, relative to the given SVG element. */
export function pointerScreenPoint(svgEl: SVGSVGElement, e: PointerEvent): Point {
  const r = svgEl.getBoundingClientRect();
  return { x: e.clientX - r.left, y: e.clientY - r.top };
}
